/** @jsx jsx */

import { Fragment } from 'react';

import { Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import CtaCreateZap from 'app/developer-v3/components/CtaCreateZap';
import DismissableHelpBox from 'app/developer-v3/components/DismissableHelpBox';
import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { LayoutStyles } from 'app/developer-v3/layouts/constants';

type Props = {
  apiUrl: string;
  isSetup: boolean;
};

const Styles = {
  root: css`
    margin: ${LayoutStyles.verticalPadding} ${LayoutStyles.horizontalPadding}
      0px;
  `,
};

export default function CTA({ apiUrl, isSetup }: Props) {
  return (
    <div css={Styles.root}>
      {isSetup ? (
        <CtaCreateZap type="trigger" />
      ) : (
        <DismissableHelpBox
          css={Styles.root}
          description={
            <Fragment>
              <Text tag="p">
                Let users customize the trigger to watch for specific items with
                the Zap Editor form. Add input fields so users can select or
                enter data, then Zapier will send it to your API.{' '}
                <Link
                  href={`${BASE_DOC_URL_VB}/build/input-designer`}
                  target="_blank"
                >
                  Learn More
                </Link>
                .
              </Text>
              <Text tag="p">
                <em>
                  If your trigger doesn’t include user customizable options,
                  skip ahead to <Link href={apiUrl}>API Configuration</Link>.
                </em>
              </Text>
            </Fragment>
          }
          heading="Add Input Form Fields"
          persistId="developer-add-trigger-input-fields"
        />
      )}
    </div>
  );
}
